export default __webpack_public_path__ + "static/media/amzSfp.bb383f6c.svg";